import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalizationModule } from './localization/localization.module';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { LayoutModule } from './layouts/layout.module';
import { ConfigModule } from './config/config.module';
import { SettingsModule } from './settings/settings.module';
import { PluginsModule } from './plugins/plugins.module';
import { ToastModule } from './toast/toast.module';
import { MenuModule } from './menu/menu.module';
import { CoreRoutingModule } from './core-routing.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { RoutingModule } from './routing/routing.module';
import { FormsModule } from './forms/forms.module';
import { SupportModule } from './support/support.module';
import { EntityModule } from './entities/entity.module';
import { RouterModule } from '@angular/router';
import { UsersModule } from './pages/users/users.module';
import { CoreBootstrapModule } from './core-bootstrap.module';
import { CurrencyModule } from './currency/currency.module';
import { ErrorPagesModule } from './pages/errors/error-pages.module';
import { AuthenticationRoutingModule } from './authentication/pages/authentication-routing.module';
import { ChassisAlertModule } from './alerts/alert.module';
import { ChassisModalModule } from './modals/modals.module';
import { RolesModule } from './pages/roles/roles.module';
import { SettingsPageModule } from './pages/settings/settings-page.module';
import { EntitiesPagesModule } from './pages/entities/entities-pages.module';
import { TenantsPagesModule } from './pages/tenants/tenants-pages.module';
import { CategoryModule } from './categories/category.module';
import { FilesModule } from './files/files.module';
import { QuickAdditModule } from './quick-addit/quick-addit.module';
import { AuthenticationPluginsModule } from './authentication/plugins/authentication-plugins.module';
import { SettingsPageRoutingModule } from './pages/settings/settings-page-routing.module';
import { ActivitiesModule } from './activities/activities.module';
import { FollowsModule } from './follows/follows.module';
import { AbstractPluginsModule } from './plugins/abstract-plugins/list/abstract-plugins.module';
import { ChassisDashboardsModule } from './dashboards/dashboards.module';
import { DatatablesModule } from './datatables/datatables.module';
import { HookSystemModule } from '@kaiser-software/hook-system';
import { ZebraPrintModule } from '@kaiser-software/zebra-print';
import { Environment } from '@kaiser-software/chassis-core';
import { CoreResourcesModule } from '@kaiser-software/chassis-core/src/app/resources/chassis-resources.module';

@NgModule({
    imports: [
        RouterModule.forRoot([]),
        RoutingModule.forRoot(),
        SupportModule.forRoot(),
        MenuModule.forRoot(),
        BootstrapModule.forRoot(),
        CoreRoutingModule,
        CoreBootstrapModule,
        LocalizationModule.forRoot(),
        ConfigModule.forRoot(),
        LayoutModule.forRoot(),
        PluginsModule.forRoot(),
        EntityModule.forRoot(),
        CurrencyModule.forRoot(),
        ChassisAlertModule.forRoot(),
        ChassisModalModule.forRoot(),
        FormsModule,
        DatatablesModule.forRoot(),
        CategoryModule,
        FilesModule,
        ToastModule,
        AuthenticationModule.forRoot(),
        AuthenticationRoutingModule,
        AuthenticationPluginsModule,
        SettingsModule.forRoot(),
        SettingsPageRoutingModule,
        SettingsPageModule,
        UsersModule,
        RolesModule,
        EntitiesPagesModule,
        TenantsPagesModule,
        ErrorPagesModule,
        QuickAdditModule.forRoot(),
        ActivitiesModule,
        FollowsModule,
        AbstractPluginsModule,
        ChassisDashboardsModule,
        HookSystemModule.forRoot(),
        ZebraPrintModule.forRoot(),
        CoreResourcesModule.forRoot(),
    ],
    declarations: [],
    providers: [],
    exports: [
        RouterModule,
        RoutingModule,
        BootstrapModule,
        CoreRoutingModule,
        AuthenticationModule,
        LocalizationModule,
        CoreBootstrapModule,
        ConfigModule,
        LayoutModule,
        SettingsModule,
        PluginsModule,
        SupportModule,
        EntityModule,
        CurrencyModule,
        ChassisAlertModule,
        ChassisModalModule,
        FormsModule,
        CategoryModule,
        FilesModule,
        ToastModule,
        MenuModule,
        AuthenticationRoutingModule,
        AuthenticationPluginsModule,
        SettingsPageModule,
        UsersModule,
        RolesModule,
        EntitiesPagesModule,
        TenantsPagesModule,
        ErrorPagesModule,
        QuickAdditModule,
        AbstractPluginsModule,
        DatatablesModule,
        ChassisDashboardsModule
    ]
})
export class CoreModule {

    constructor() {
        console.log('Chassis Core Module bootstrapped.');
    }

    public static forRoot(environment?: Environment): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [{
                // Make the environment file injectable.
                provide: 'ENVIRONMENT',
                useValue: environment
            }]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/core.module.ts